//@ts-nocheck
import { Input, InputNumber, InputProps, AutoComplete } from 'antd';
import { PasswordInput } from 'antd-password-input-strength';
import styled from 'styled-components';

export {
  FormInput,
  FormPasswordInput,
  SCOPE_FORM_INPUT_CLASS,
} from '@monorepo/shared-lib';

const { TextArea } = Input;

export const FormPasswordInputWithValidation = styled(PasswordInput)`
  width: 330px;
  border-radius: 0;
  border: 1px solid transparent;
  padding: 6px 11px;
  height: 45px;
  margin-right: ${(props) => (props.rmargin ? props.rmargin : '0')};
  &:hover,
  &:focus,
  &:active {
    border: 1px solid var(--color-primary, #41aaaf);
    box-shadow: none;
  }
`;

interface RoundInputProps extends InputProps {
  width?: string;
  height?: string;
  bg_color?: string;
}

export const SCOPE_ROUND_INPUT_CLASS = 'scope-round-input';

export const RoundInput = styled(Input).attrs((props) => ({
  variant: props.variant ?? 'borderless',
  className: [props.className, SCOPE_ROUND_INPUT_CLASS].filter(Boolean).join(' '),
}))<RoundInputProps>`
  &&.ant-input,
  &&.ant-input-affix-wrapper,
  &&.ant-input-outlined,
  &&.ant-input-affix-wrapper-outlined {
    width: ${(props) => (props.width ? props.width : '305px')};
    height: ${(props) => (props.height ? props.height : '40px')};
    border-radius: 100px !important;
    border: 1px solid transparent !important;
    font-size: 14px;
    background: ${(props) =>
      props.bg_color ? props.bg_color : 'var(--color-surface, #f3f7f8)'} !important;
    box-shadow: none !important;
    color: var(--color-text-base, #2e2e2e) !important;
  }

  &&.ant-input-affix-wrapper .ant-input,
  &&.ant-input-affix-wrapper .ant-input-outlined {
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    outline: none !important;
    background: transparent !important;
    color: var(--color-text-base, #2e2e2e) !important;
  }

  &&.ant-input,
  &&.ant-input-outlined {
    color: var(--color-text-base, #2e2e2e) !important;
  }

  .ant-input-prefix,
  .ant-input-prefix .anticon {
    color: var(--color-text-muted, #5a6a6a) !important;
  }

  &::placeholder,
  &&.ant-input-affix-wrapper input::placeholder {
    color: var(--color-placeholder, #5a6a6a) !important;
  }

  &&.ant-input:hover,
  &&.ant-input:focus,
  &&.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,
  &&.ant-input-affix-wrapper-focused,
  &&.ant-input-affix-wrapper:focus,
  &&.ant-input-affix-wrapper:focus-within {
    border: 1px solid var(--color-primary, #41aaaf) !important;
    box-shadow: none !important;
  }

  &&.ant-input-affix-wrapper-focused .ant-input,
  &&.ant-input-affix-wrapper:focus-within .ant-input {
    border: none !important;
    box-shadow: none !important;
  }
`;

export const SCOPE_ROUND_AUTOCOMPLETE_CLASS = 'scope-round-autocomplete';

export const RoundAutoComplete = styled(AutoComplete).attrs((props) => ({
  className: [props.className, SCOPE_ROUND_AUTOCOMPLETE_CLASS]
    .filter(Boolean)
    .join(' '),
  'aria-label':
    props['aria-label'] ??
    (typeof props.placeholder === 'string' ? props.placeholder : undefined),
}))`
  width: ${(props) => (props.width ? props.width : '305px')};

  && .ant-select-selector {
    height: ${(props) => (props.height ? props.height : '40px')} !important;
    border-radius: 100px !important;
    border: 1px solid transparent !important;
    font-size: 14px;
    background: ${(props) =>
      props.bg_color ? props.bg_color : 'var(--color-surface, #f3f7f8)'} !important;
    box-shadow: none !important;
    display: flex;
    align-items: center;
    padding-right: 28px; /* space for clear icon */
    color: var(--color-text-base, #2e2e2e) !important;
  }

  && .ant-select-selection-search-input {
    height: 100% !important;
    padding-right: 12px; /* avoid overlapping clear icon */
    color: var(--color-text-base, #2e2e2e) !important;
  }

  && .ant-select-selection-placeholder {
    color: var(--color-placeholder, #5a6a6a) !important;
  }

  &&:not(.ant-select-disabled):hover .ant-select-selector,
  &&.ant-select-focused .ant-select-selector,
  &&.ant-select-open .ant-select-selector {
    border: 1px solid var(--color-primary, #41aaaf) !important;
    box-shadow: none !important;
  }

  /* Align the clear (x) icon vertically and position consistently */
  .ant-select-clear {
    right: 10px;
    top: 7px;
    bottom: 0;
    transform: none;
    margin: auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-select-dropdown {
    .ant-select-item {
      padding: 8px 12px;
    }
  }
`;

export const OTPInput = styled(Input.OTP)`
  #mfa-code > input {
    width: 55px !important;
    height: 65px !important;
    border-radius: 5px;
  }
`;

export const FormTextArea = styled(TextArea)`
  width: 317px !important;
  height: 161px !important;
  border: 1px solid #e9f6f7 !important;
`;

export const NumericInput = styled(InputNumber)`
  input.ant-input-number-input {
    font-family: Inter;
    font-size: 14px !important;
    font-weight: 600 !important;
    line-height: 27px !important;
    text-align: center !important;
    width: 53px !important;
    height: 40px !important;
  }

  .ant-input-number-outlined {
    border-right: none;
    border-left: none;
    border-color: var(--color-border, #dbeae3);
  }

  .ant-input-number-group-addon {
    border-color: var(--color-border, #dbeae3);
    background-color: var(--color-surface-raised, #ffffff);
    color: var(--color-text-base, #2e2e2e);
  }

  .ant-input-number-group-wrapper .ant-input-number-outlined,
  .ant-input-number-outlined {
    border-color: var(--color-border, #dbeae3);
    background-color: var(--color-surface, #f3f7f8);
  }

  .ant-input-number-group-wrapper-disabled {
    border-right: none;
    border-left: none;
    border-color: var(--color-border, #dbeae3) !important;
  }

  > div > div > span[disabled] {
    pointer-events: none !important;
  }

  > div > div:has(> span[disabled]) {
    background-color: rgba(46, 46, 46, 0.04) !important;
  }

  ${(props) =>
    props.hasError &&
    `.ant-input-number-outlined {
    border-color: #D13131;
  }

    .ant-input-number-group-addon {
    border-color: #D13131;
  }
    `}
`;
